import { createApp } from 'vue'
import BasketAside from './BasketAside'

const el = '.kb-component--basket-aside'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((BasketAsideDOM) => {
            const component = createApp(BasketAside, { asideResults }).use(
                Store
            )
            component.mount(BasketAsideDOM)
        })
    }
}
